import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportOtherExpencesPage } from './report-other-expences.page';

const routes: Routes = [
  {
    path: '',
    component: ReportOtherExpencesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportOtherExpencesPageRoutingModule {}
